/*
Copyright (c) 2024, HP Development Company, L.P. All rights reserved.
This software contains confidential and proprietary information of HP.
The user of this software agrees not to disclose, disseminate or copy
such Confidential Information and shall use the software only in accordance
with the terms of the license agreement the user entered into with HP.
*/

import * as React from 'react';
import DirectionContext from './direction_context';

export default function useDirection() {
  const { isRTL = false, locale = 'en-US' } =
    React.useContext(DirectionContext);

  return { isRTL, locale };
}
